import React, { useState, useContext, useEffect } from 'react';
import SideNav from '../shared/SideNav';
import Breadcrumb from '../../shared/Breadcrumb';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Util from '../../../Util';
import { apiRoutes } from '../../../AppSettings';
import Modal from 'react-bootstrap/Modal';

const Appoinments = () => {
    const { userState } = useContext(AuthContext);
    const [doctor, setDoctor] = useState(userState.loggedInUser);
    const [appoinments, setAppoinments] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [selectedAppoinment, setSelectedAppoinment] = useState({});

    const loggedInDoctorId = userState.user.userId;

    const updateDoctor = (data) => {
        setDoctor(data);
    };

    const updateAppoinments = (data) => {
        setAppoinments(data);
    }

    useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer ' + userState.token
            }
        };

        //    axios.get('http://localhost:59231/api/doctor/appoinments/'+ loggedInDoctorId, options)
        axios.get(apiRoutes.getAppoinments + loggedInDoctorId, options)
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    console.log(data);
                    updateAppoinments(data.data);
                }
            }, (error) => {
                console.log(error);
            });
    }, []);

    const OpenModel = (appoinment) => {
        setSelectedAppoinment(appoinment);
        setModalShow(true);
    }

    const dateIsInPast = (date, time) => {
        if (date != undefined) {
            const datetoCompare = Util.setHours(new Date(date), time);
            console.log(datetoCompare)
            if (datetoCompare < new Date())
                return true;
            return false;
        }
    }
    return (
        <div>
            <Breadcrumb title="Appointments" />
            <div className="content">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='appointmenta' user={doctor} />
                        </div>

                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="appointments">
                                {
                                    appoinments.map(a => (
                                        <div key={a.appoinmentId} className="appointment-list">
                                            <div className="profile-info-widget">
                                                {/* <a href="patient-profile.html" className="booking-doc-img">
                                                    <img src={Util.loadImage(a.patient.profileImage)} alt="User Image" />
                                                </a> */
                                                    console.log(a)
                                                }

                                                <Link className="booking-doc-img"
                                                    to={
                                                        {
                                                            pathname: '/PatientProfile',
                                                            state: {
                                                                patientId: a.patient.patientId
                                                            }
                                                        }
                                                    }>
                                                    <img className="avatar-img rounded-circle" src={Util.loadImage(a.patient.profileImage)} alt="User Image" />
                                                </Link>


                                                <div className="profile-det-info">
                                                    {/* <h3><Link to={"/PatientProfile" + a.patient.patientId}>{a.patient.firstName} {a.patient.lastName}</Link></h3> */}
                                                    <Link to={
                                                        {
                                                            pathname: '/PatientProfile',
                                                            state: {
                                                                patientId: a.patient.patientId
                                                            }
                                                        }
                                                    }>{a.patient.firstName} {a.patient.lastName}</Link>

                                                    <div className="patient-details">
                                                        <h5><i className="far fa-clock"></i> {Util.getFormatDate({ date: a.appoinmentDate })}, {a.appoinmentTime}</h5>
                                                        <h5><i className="fas fa-map-marker-alt"></i> {a.patient.state}, {a.patient.country}</h5>
                                                        <h5><i className="fas fa-envelope"></i> {a.patient.emailAddress}</h5>
                                                        <h5 className="mb-0"><i className="fas fa-phone"></i> {a.patient.phone}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="appointment-action">
                                                <a onClick={e => OpenModel(a)} className="btn btn-sm bg-info-light" data-toggle="modal" data-target="#appt_details">
                                                    <i className="far fa-eye"></i> View
                                                </a>
                                                {/* <a href="javascript:void(0);" className="btn btn-sm bg-success-light">
                                                            <i className="fas fa-check"></i> Accept
                                                        </a>
                                                        <a href="javascript:void(0);" className="btn btn-sm bg-danger-light">
                                                            <i className="fas fa-times"></i> Cancel
                                                        </a> */
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={modalShow} onHide={() => setModalShow(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Appointment Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body">
                        <ul class="info-details">
                            <li>
                                <div class="details-header">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <span class="title">{selectedAppoinment.appoinmentNumber}</span>
                                            <span class="text">{Util.getFormatDate({ date: selectedAppoinment.appoinmentDate })} {selectedAppoinment.appoinmentTime}</span>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="text-right">
                                                <button type="button" class="btn bg-success-light btn-sm" id="topup_status">{dateIsInPast(selectedAppoinment.appoinmentDate, selectedAppoinment.appoinmentTime) ? 'Completed' : 'Pending'} </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <span class="title">Status:</span>
                                <span class="text">{selectedAppoinment.isActive ? 'Confirmed' : 'Cancelled'}</span>
                            </li>
                            <li>
                                <span class="title">Confirm Date:</span>
                                <span class="text">{Util.getFormatDate({ date: selectedAppoinment.appoinmentDate })}</span>
                            </li>
                            <li>
                                <span class="title">Paid Amount</span>
                                <span class="text">${selectedAppoinment.invoices != undefined && selectedAppoinment.invoices.reduce((a, b) => a + (b.totalAmount || 0), 0)}</span>
                            </li>
                        </ul>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};
export default Appoinments;